

/* profile-menu-dialog.component.ts */
import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from "../../component/layout/element/button.component";
import { updateUser, UpdateUserVariables } from '@dataconnect/account';
import { Store } from '@ngrx/store';
import { AccountActions, accountFeature } from '../../store/account.store';
import { Logger } from '../../helper/logger';
import { lastValueFrom, take } from 'rxjs';
import { Functions } from '@angular/fire/functions';
const log = new Logger("UserDialog");
import { LOCATION_LABEL } from '../../../../globalTypes/configs';

export interface UserData {
  user: UpdateUserVariables
}
  

@Component({
  selector: 'msh-user-dialog',
  standalone: true,
  imports: [MatIconModule, FormsModule, MatDialogModule, MatButtonModule, RouterModule, ButtonComponent],
  template: `
<div class=" z-10 relative">
  <mat-icon class="absolute top-4 right-4" [mat-dialog-close]="false">close</mat-icon>
</div>
<div class="dialog-container relative p-4 px-10 overflow-auto max-h-96 ">
  <input 
    type="text"
    placeholder="Display Name"
    name="displayName"
    [(ngModel)]="data.user.displayName"
    required />
  <div class="flex gap-4">
    <input 
      type="text"
      placeholder="Email"
      name="email"
      [(ngModel)]="data.user.email"
      class=" !w-24"
      required />
    <input 
      type="text"
      placeholder="Mobile"
      name="mobile"
      [(ngModel)]="data.user.mobile"
      required />
  </div>
    
  <div class="grid grid-cols-3 gap-3">
    <input 
      type="text"
      placeholder="Status"
      name="status"
      [(ngModel)]="data.user.statusId"
      required />
    <input 
      type="text"
      placeholder="Profile Image"
      name="profileImage"
      [(ngModel)]="data.user.profileImageId"
      required />
  </div>
</div>

<div class="bg-navy-50 gap-4 py-4 px-6 flex justify-end">
    <msh-button [cta]="'Update'" (onClick)="updateUser()" [disabled]="!data.user || !data.user.displayName" [mat-dialog-close]="data.user"></msh-button>
</div>
  `,
  styles: ``
})
export class UserDialog {
  
  constructor(
    private functions: Functions,
    private store: Store,
    public dialogRef: MatDialogRef<UserDialog>,
    @Inject(MAT_DIALOG_DATA) public data: UserData,
  ){
    // this.address = (this.data.address) ? JSON.parse(JSON.stringify(this.data.address)) : {};
  }

  async updateUser(){
    let userUpdateData
    const location = await lastValueFrom(this.store.select(accountFeature.selectLocation).pipe(take(1)))
    if(!location || !location.id) throw new Error("No current "+LOCATION_LABEL+" available to attach address to")
    const { id, displayName, email, mobile, statusId, profileImageId } = this.data.user;
    const vars: UpdateUserVariables = {
      id, 
      displayName,
      email,
      mobile,
      statusId,
      profileImageId,
      locationId: location.id,
    }
    try {
      log.log({vars})
      const userUpdateRef = await updateUser(vars);
      userUpdateData = userUpdateRef.data.user_upsert;
      log.log({userUpdateData})
      // update store...
    } catch(error) {
      console.error({error})
    }

    this.dialogRef.close(userUpdateData)
  }

}
